import React from 'react';
import Home from '../pages/home/Home';
import { Carousel } from 'antd';

const Hero = () => {
  function onChange(a, b, c) {
    console.log(a, b, c);
  }

  const contentStyle = {
    height: '70vh',
    width: '100%',
    objectFit: 'cover',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
    background: '#364d79',
    opacity: '0.5',
  };
  return (
    <div className="container-hero">
      <div className="inner-hero">
        <h1>
          Karir impianmu ada disini Dapatkan pekerjaan yang cocok untukmu di
          Website ini.
        </h1>
      </div>
      <Carousel afterChange={onChange}>
        <div>
          <img
            src="https://media.istockphoto.com/photos/cheerful-woman-in-the-park-with-her-friends-picture-id1125540923?k=20&m=1125540923&s=612x612&w=0&h=wPwsiGqvTkOmgQk9cfDnHjwF2QufCYWKJ7JOw46Ms6U="
            style={contentStyle}
          />
        </div>
        <div>
          <img
            src="https://media.istockphoto.com/photos/cheerful-woman-in-the-park-with-her-friends-picture-id1125540923?k=20&m=1125540923&s=612x612&w=0&h=wPwsiGqvTkOmgQk9cfDnHjwF2QufCYWKJ7JOw46Ms6U="
            style={contentStyle}
          />
        </div>
      </Carousel>
    </div>
  );
};

export default Hero;
